import smoothAnnotation from './smoothAnnotation';

export default {
  smoothAnnotation,
};

export { smoothAnnotation };
